import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import Header from "components/Header/Header.js";
import styles from "assets/jss/material-kit-react/components/admin/menuStyle.js";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Button from "components/CustomButtons/Button.js";
import {
  useParams
} from "react-router-dom";
const useStyles = makeStyles(styles);

export default function Menu(props) {
  const classes = useStyles();
  let { id } = useParams();
  var active = 0
  if (id == "Dashboard")
    active = 0;
  else if (id == "Payment")
    active = 1;
  else if (id == "ContactUs")
    active = 2;
  else
    active = 0;
  var showSubMenu = false;
  if (active >= 6 && active <= 10) {
    showSubMenu = true
  }

  return (
    <div >
      <div className={classes.topSection}><List className={classes.list}>
        <ListItem className={classes.listItem}>
          <Button
            href="/Admin/Section/Dashboard"
            className={classes.navLink + " " + (active == 0 ? classes.navLinkActive : "")}
            color="transparent">
            داشبورد
          </Button>
        </ListItem>
        <ListItem className={classes.listItem}>
          <Button
            href="/Admin/Section/Payment/"
            className={classes.navLink + " " + (active == 1 ? classes.navLinkActive : "")}
            color="transparent">
            پرداخت‌ها
          </Button>
        </ListItem>
        <ListItem className={classes.listItem}>
          <Button
            href="/Admin/Section/ContactUs/"
            className={classes.navLink + " " + (active == 2 ? classes.navLinkActive : "")}
            color="transparent">
            ارتباط با ما
          </Button>
        </ListItem>
      </List></div>
      {showSubMenu && (
        <div className={classes.section} >
          <List className={classes.list}>
            <ListItem className={classes.listItem}>
              <Button
                href="/Admin/Section/Dashboard"
                className={classes.subNavLink + " " + (active == 0 ? classes.subNavLinkActive : "")}
                color="transparent">

              </Button>
            </ListItem>
          </List>
        </div>
      )}
    </div>
  );
}
